import { CSVTranformationProfile, CSVProfile } from '../../types'
import { MwChartDonutChartOptions, SeriesData } from '@meltwater/mw-visualizations-angularjs'
import { BaseVisualization } from '../base/base-visualization-component'
import orderBy from 'lodash/orderBy'

export class DonutChartLoopComponent extends BaseVisualization {
 static config = {
  selector: 'donutChartLoopComponent',
  controller: DonutChartLoopComponent,
  template: `
            <div layout="row" style="padding-top: 40px;" layout-wrap flex af__chart__container af__medium__tall class="j-center">
                <div flex layout="column"
                    flex-sm="33"
                    flex-md="33"
                    ng-if="!$ctrl.isLoading && !$ctrl.isObjEmpty($ctrl.visualizationList)"
                    ng-repeat="visualization in $ctrl.visualizationList">

                    <div class="flex-item" style="text-align: center;"> {{visualization.title}} - {{$ctrl.numberTransform(visualization.total)}}</div>
                    <div class="flex-item" style="height:200px">
                        <mw-chart-donut
                            chart-data="visualization.visualizationData"
                            chart-options="visualization.visualizationOptions"
                            get-api="$ctrl.getApi(API)">
                        </mw-chart-donut>
                    </div>
                </div>
            </div>

            <div layout="row" layout-wrap layout-align="center center" style="padding-top: 40px;">
                <span ng-repeat="footerData in $ctrl.footerDataList" style="font-size: 12px; padding-right: 20px;">
                    <md-icon md-svg-icon="meltwater:circle-closed" 
                        ng-style="{'width': '10px', 'min-width': '10px', 'color': footerData.color}">
                    </md-icon> 
                    {{footerData.text}} 
                </span>
            </div>
        `,
  bindings: BaseVisualization.config.bindings,
 }

 /**
  * Default chart properties
  */
 public seriesTitle: string = 'Occurences'
 public seriesColors: [string]
 public maxPhraseLength: number = 20

 /**
  * List of chart data & option
  */
 public visualizationList = []

 /**
  * Holds the footer data object. e.g. color, text etc
  */
 public footerDataList = []

 // default CSV header columns. Can be overriden in sub class.
 public csvHeaders = ['Category', 'Count']

 /**
  * CSV transformation profile. Defines how csv key value transformed
  */
 public transformationProfiles: CSVTranformationProfile[] = []

 $onChanges(changes) {
  if (this.hasChanges(changes.visualizationMetaData)) {
   this.setMetaData(changes.visualizationMetaData.currentValue)
   this.setProperties()
  }
  if (this.hasChanges(changes.vizData)) {
   this.setProperties()
   this.prepareVisualizations(changes.vizData.currentValue)
   this.prepareFooterData(changes.vizData.currentValue)
   this.buildCSVExportProfile()
  }
 }

 setProperties() {
  this.seriesColors = this.colorUtils.compareMetaColors(this.visualizationMetaData)
 }

 /**
  * Creates the multi chart component data to be displayed.
  * @param payload strutured data object response recieved for multiple donut chart
  * @see API [View Request Documentation](https://explore-api.dev.alphaflight.meltwater.io/swagger-ui.html#)
  */
 prepareVisualizations = payload => {
  let data = this.namingUtils.returnData(payload.data)

  data.forEach(element => {
   this.visualizationList.push({
    title: element.key,
    total: this.getTotal(element.value),
    visualizationData: this.getVisualizationData(element),
    visualizationOptions: this.getVisualizationOptions(
     this.getIndividualChartColors(element.value)
    ),
   })
  })
  this.visualizationList = orderBy(this.visualizationList, ['total'], ['desc']) // Use Lodash to sort array by 'nam
 }

 getIndividualChartColors(data) {
  let colors = []
  data.forEach(queryName => {
   colors.push(this.colorUtils.compareMetaByName(queryName.key, this.visualizationMetaData))
  })
  return colors
 }
 /**
  * Creates new Hight Chart SeriesData object
  * @param element object to create High Chart Series Data @See SeriesData
  */
 getVisualizationData(element) {
  return new SeriesData({
   name: element.key,
   data: element.value,
  })
 }

 getTotal = data => {
  return data.reduce(function(prev, cur) {
   return prev + cur.value
  }, 0)
 }

 /**
  * Takes the first key item and use it's array value as
  * the footer text. Potential issue is when this
  * first item does not have all the values needed for footer.
  * @param payload object to create footer data. The first item is used.
  */
 prepareFooterData(payload) {
  this.footerDataList = []

  // take the first key item and use it's array value.
  let data: [] = this.visualizationMetaData
  if (data.length > 0) {
   data.map((element: any, idx) => {
    this.footerDataList.push({
     text: element.name,
     color: element.color,
    })
   })
  }
 }

 /**
  * MW high chart click event function.
  */
 onPointClick = event => {
  this.triggerUpdate(this.updatePayload('FILTER_CHANGE', 'append', 'subKeyword', event.key))
 }

 /**
  * MW high chart tooltip formatter.
  */
 tooltipFormatter = point => {
  return `${point.sliceName}<br><strong>${this.seriesTitle}:</strong> ${point.value}`
 }

 /**
  * MW hight chart donut options.
  */
 getVisualizationOptions = colors => {
  return new MwChartDonutChartOptions({
   seriesColors: colors,
   onPointClick: this.onPointClick,
   tooltipFormatter: this.tooltipFormatter,
   maxPhraseLength: this.maxPhraseLength,
   areDataLabelsVisible: false,
  })
 }

 /**
  * Build CSV export profile which includes data, options
  * and the key transformation types if any.
  */
 buildCSVExportProfile() {
  this.csvExportProfiles = []

  let exportData: CSVProfile = {
   data: Object.assign({}, this.vizData.data),
   csvOptions: { title: this.visTitle, headers: this.csvHeaders },
   transformationProfiles: this.transformationProfiles,
  }

  this.csvExportProfiles.push(exportData)
 }
}
